<template>
    <div class="footer">
        <div class="footer__top">
            <div class="footer__top__left">
                <div class="footer__top__label">Tulajdonos</div>
                <div class="footer__top__title">{{ footerData.owner.name }}</div>
                <MailTo class="footer__top__email" :email="footerData.owner.email"/>
                <div class="footer__top__left__address">{{ footerData.owner.address }}</div>
                <a class="footer__top__left__phone" :href="formatPhoneNumber(footerData.owner.phone)">{{ footerData.owner.phone }}</a>
            </div>
            <div class="footer__top__right">
                <div class="footer__top__label">Rendszertámogatás</div>
                <div class="footer__top__title">{{ footerData.support.name }}</div>
                <MailTo class="footer__top__email" :email="footerData.support.email"/>
                <div class="footer__top__left__address">{{ footerData.support.address }}</div>
                <a class="footer__top__left__phone" :href="formatPhoneNumber(footerData.support.phone)">{{ footerData.owner.phone }}</a>
            </div>
        </div>
        <div class="footer__bottom">
            <div class="footer__bottom__left">
                <div>© {{getCurrentLocalYear}} Semmelweis Egyetem - Minden jog fentartva</div>
            </div>
            <div class="footer__bottom__right">
                <div class="footer__bottom__right_wrapper">
                    <div>Adatvédelem</div>
                </div>
                <div class="footer__bottom__right_wrapper">
                    <div>Cookie-tájékoztató</div>
                </div>
                <div class="footer__bottom__right_wrapper">
                    <div>Informatikai Főigazgatóság honlapja</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MailTo from "./MailTo.vue";
export default {
    components: {MailTo},

    methods: {
        formatPhoneNumber(value) {
            return 'tel:' + (value.match(new RegExp('[+0-9]+', 'g'))?.join(''));
        },
    },

    computed: {
        getCurrentLocalYear() {
            return (new Date()).getFullYear();
        },

        footerData() {
            return window.frontendConfiguration.vueJs.footer;
        }
    }
}
</script>

<style lang="scss">
@import "@scss/components/Footer.scss";
</style>
